import { isStatusValid } from '@mchat-rf/consulta-seguimento/utils-consultaSeguimento'
import { isEmpty } from 'bold-ui'
import { SimNaoEnum } from 'components/form'
import { createValidator, ErrorObject, required } from 'util/validation'

import { ConsultaSeguimentoPergunta02Model } from './model-consultaSeguimentoPergunta02'

export const validatorConsultaSeguimentoPergunta02 = createValidator<ConsultaSeguimentoPergunta02Model>(
  {
    resultado: required,
    status: isStatusValid,
    PERGUNTA_02_FEZ_EXAME: required,
  },
  (values: ConsultaSeguimentoPergunta02Model, errors: ErrorObject<ConsultaSeguimentoPergunta02Model>) => {
    const ignoraPessoas = values?.PERGUNTA_02_IGNORA?.IGNORA_PESSOAS
    const ignoraSons = values?.PERGUNTA_02_IGNORA?.IGNORA_SONS

    if (isEmpty(ignoraPessoas) && isEmpty(ignoraSons)) {
      errors.PERGUNTA_02_IGNORA = {
        IGNORA_PESSOAS: required(ignoraPessoas),
        IGNORA_SONS: required(ignoraSons),
      }
    }

    if (isEmpty(ignoraPessoas) && ignoraSons === SimNaoEnum.NAO) {
      errors.PERGUNTA_02_IGNORA = {
        IGNORA_PESSOAS: required(ignoraPessoas),
      }
    }

    if (isEmpty(ignoraSons) && ignoraPessoas === SimNaoEnum.NAO) {
      errors.PERGUNTA_02_IGNORA = {
        IGNORA_SONS: required(ignoraSons),
      }
    }

    if (values?.PERGUNTA_02_FEZ_EXAME === SimNaoEnum.SIM) {
      errors.PERGUNTA_02_RESULTADO_EXAME = required(values.PERGUNTA_02_RESULTADO_EXAME)
    }

    return errors
  }
)
